import { formatToForm } from '@mixins/currency';
// eslint-disable-next-line import/no-cycle
import Invoice from '@models/invoice';
import Model from '@models/model';

export const INVOICE_TRANSACTION_TYPE_REFUND = 'Refund';
export const INVOICE_TRANSACTION_TYPE_PAYMENT = 'Payment';
export const INVOICE_TRANSACTION_TYPE_REVERSAL = 'Reversal';
export const INVOICE_TRANSACTION_TYPE_CREDIT_INVOICE = 'Credit Invoice';
export const INVOICE_TRANSACTION_TYPE_TRANSFER = 'Transfer';
export const INVOICE_TRANSACTION_TYPE_CREDIT = 'Credit';
export const INVOICE_TRANSACTION_TYPE_INVOICE = 'Invoice';
export const INVOICE_TRANSACTION_TYPE_CUSTOMER_CREDIT = 'Customer Credit';
export const INVOICE_TRANSACTION_TYPE_WRITE_OFF = 'Write Off';
export const INVOICE_TRANSACTION_TYPE_CREDIT_ALLOCATION = 'Credit Allocation';

export const INVOICE_TRANSACTION_TYPES = [
    { id: INVOICE_TRANSACTION_TYPE_PAYMENT, text: INVOICE_TRANSACTION_TYPE_PAYMENT },
    { id: INVOICE_TRANSACTION_TYPE_CREDIT_INVOICE, text: INVOICE_TRANSACTION_TYPE_CREDIT_INVOICE, disable: true },
    { id: INVOICE_TRANSACTION_TYPE_CREDIT, text: INVOICE_TRANSACTION_TYPE_CREDIT, disable: true },
    { id: INVOICE_TRANSACTION_TYPE_REFUND, text: INVOICE_TRANSACTION_TYPE_REFUND, disable: true },
    { id: INVOICE_TRANSACTION_TYPE_REVERSAL, text: INVOICE_TRANSACTION_TYPE_REVERSAL, disable: true },
    { id: INVOICE_TRANSACTION_TYPE_CREDIT_ALLOCATION, text: INVOICE_TRANSACTION_TYPE_CREDIT_ALLOCATION, disable: true },
];

export const INVOICE_TRANSACTION_DOCUMENT_TYPES = [
    INVOICE_TRANSACTION_TYPE_INVOICE,
    INVOICE_TRANSACTION_TYPE_CREDIT_INVOICE,
    INVOICE_TRANSACTION_TYPE_CUSTOMER_CREDIT,
    INVOICE_TRANSACTION_TYPE_WRITE_OFF,
];

export default class InvoiceTransaction extends Model {
    static className = 'InvoiceTransaction';

    constructor(data) {
        super();
        this.setAttributes(data);
    }

    resource() {
        return 'transactions';
    }

    get formFieldCasts() {
        return {
            amount: (value) => {
                const amount = Math.abs(value);
                return formatToForm(amount);
            },
        };
    }

    relations() {
        return {
            applied_from: InvoiceTransaction,
            invoice: Invoice,
        };
    }

    isRefund() {
        return this.type === INVOICE_TRANSACTION_TYPE_REFUND;
    }

    isCreditInvoice() {
        return this.type === INVOICE_TRANSACTION_TYPE_CREDIT_INVOICE || this.type === INVOICE_TRANSACTION_TYPE_CREDIT;
    }

    isReversal() {
        return this.type === INVOICE_TRANSACTION_TYPE_REVERSAL;
    }

    isPayment() {
        return this.type === INVOICE_TRANSACTION_TYPE_PAYMENT;
    }

    isTransfer() {
        return this.type === INVOICE_TRANSACTION_TYPE_TRANSFER;
    }

    isCreditAllocation() {
        return this.type === INVOICE_TRANSACTION_TYPE_CREDIT_ALLOCATION;
    }

    isNotTransactionDocument() {
        return INVOICE_TRANSACTION_DOCUMENT_TYPES.includes(this.type) === false;
    }
}
